import React from 'react';
import { Form } from 'react-bootstrap';
import { FormData } from './types';
import { NorwegianDatepicker } from 'components/NorwegianDatepicker';

interface LeftColumnFormProps {
  formData: FormData;
  handleChange: (field: string, value: any) => void;
}

const LeftColumnForm: React.FC<LeftColumnFormProps> = ({ formData, handleChange }) => {
  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Medlem hos</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn medlem hos"
          value={formData.medlemHos || ''}
          onChange={(e) => handleChange('medlemHos', e.target.value)}
        />

        {/* Markedskjede relaterte felter */}
        <div className="row mt-2">
          <div className="col-md-4">
            <Form.Label>Innmeldingsdato</Form.Label>
            <NorwegianDatepicker
              value={formData?.medlemFraOgMedDato}
              onChange={(e) => handleChange('medlemFraOgMedDato', e)}
            />
          </div>
          <div className="col-md-4">
            <Form.Label>Utmeldingsdato</Form.Label>
            <NorwegianDatepicker
              value={formData?.medlemTilOgMedDato}
              onChange={(e) => handleChange('medlemTilOgMedDato', e)}
            />
          </div>
          <div className="col-md-4">
            <Form.Label>Medlemsnummer</Form.Label>
            <Form.Control
              type="text"
              value={formData.medlemsNummer || ''}
              onChange={(e) => handleChange('medlemsNummer', e.target.value)}
            />
          </div>
        </div>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Nedlagtdato</Form.Label>
        <NorwegianDatepicker
          value={formData?.nedlagtdato}
          onChange={(e) => handleChange('nedlagtdato', e)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Enhetnavn</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn enhetnavn"
          value={formData.enhetnavn}
          onChange={(e) => handleChange('enhetnavn', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Oppstart dato</Form.Label>
        <NorwegianDatepicker
          value={formData.oppstartsdato}
          onChange={(e) => handleChange('oppstartdato', e)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Omsetning</Form.Label>
        <Form.Control
          type="number"
          placeholder="Skriv inn omsetning"
          value={formData.omsetning}
          onChange={(e) => handleChange('omsetning', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>GLN</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn GLN"
          value={formData.gln}
          onChange={(e) => handleChange('gln', e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Organisasjonsnummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn organisasjonsnummer"
          value={formData.organisasjonsnummer}
          onChange={(e) => handleChange('organisasjonsnummer', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Telefonnummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn telefonnummer"
          value={formData.telefonnummer}
          onChange={(e) => handleChange('telefonnummer', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Besøksadresse</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn besøksadresse"
          value={formData.besoksadresse}
          onChange={(e) => handleChange('besoksadresse', e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Kontonummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn kontonummer"
          value={formData.kontonummer}
          onChange={(e) => handleChange('kontonummer', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Salgsareal</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn salgsareal"
          value={formData.salgsareal}
          onChange={(e) => handleChange('salgsareal', e.target.value)}
        />
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label>Butikknummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn butikknummer"
          value={formData.butikknummer}
          onChange={(e) => handleChange('butikknummer', e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Firmanavn</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn firmanavn"
          value={formData.firmanavn}
          onChange={(e) => handleChange('firmanavn', e.target.value)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>Besøk postnummer</Form.Label>
        <Form.Control
          type="text"
          placeholder="Skriv inn besøk postnummer"
          value={formData.besokpostnummer}
          onChange={(e) => handleChange('besokpostnummer', e.target.value)}
        />
      </Form.Group>
    </>
  );
};

export default LeftColumnForm;
